export const getFillValue = ({
  fill,
  figmaFileImages,
}: {
  fill: any;
  figmaFileImages: any;
}) => {
  switch (fill.type) {
    case 'SOLID': {
      return fill.color;
    }
    case 'GRADIENT_LINEAR':
    case 'GRADIENT_RADIAL':
    case 'GRADIENT_ANGULAR':
    case 'GRADIENT_DIAMOND': {
      return { gradientStops: fill.gradientStops };
    }
    case 'IMAGE': {
      const image = figmaFileImages.find(
        (fileImage: any) => fileImage.imageRef === fill.imageHash,
      );

      if (!image) {
        return { imageUrl: null, scaleMode: null };
      }

      return {
        imageUrl: image.imageUrl,
        scaleMode: fill.scaleMode,
        scalingFactor: fill.scalingFactor,
        rotation: fill.rotation,
      };
    }
    case 'VIDEO': {
      const video = figmaFileImages.find(
        (fileImage: any) => fileImage.imageRef === fill.videoHash,
      );

      if (!video) {
        return { imageUrl: null, scaleMode: null };
      }

      return {
        imageUrl: video.imageUrl,
        scaleMode: fill.scaleMode,
        scalingFactor: fill.scalingFactor,
        rotation: fill.rotation,
      };
    }
  }
};
